"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAFE_CSS_PROPERTIES_WITH_ALTERNATES = exports.SAFE_CSS_PROPERTIES_ALTERNATES = exports.SAFE_CSS_PROPERTIES = exports.CARD_ELEMENT_STYLE_VARIANT_SELECTORS = exports.CARD_ELEMENT_STYLE_VARIANTS = exports.CARD_ELEMENT_STYLE_FONTS_ATTR = void 0;
const SAFE_CSS_PROPERTIES = ['backgroundColor', 'color', 'fontFamily', 'fontSize', 'fontSmooth', 'fontStyle', 'fontVariant', 'fontWeight', 'lineHeight', 'letterSpacing', 'textAlign', 'padding', 'textDecoration', 'textShadow', 'textTransform'];
exports.SAFE_CSS_PROPERTIES = SAFE_CSS_PROPERTIES;
const SAFE_CSS_PROPERTIES_ALTERNATES = {
  fontSmooth: ['-webkit-font-smoothing', '-moz-osx-font-smoothing']
};
exports.SAFE_CSS_PROPERTIES_ALTERNATES = SAFE_CSS_PROPERTIES_ALTERNATES;
const SAFE_CSS_PROPERTIES_WITH_ALTERNATES = Object.keys(SAFE_CSS_PROPERTIES_ALTERNATES);
exports.SAFE_CSS_PROPERTIES_WITH_ALTERNATES = SAFE_CSS_PROPERTIES_WITH_ALTERNATES;
const CARD_ELEMENT_STYLE_VARIANT_SELECTORS = [':hover', ':focus', ':read-only', '::placeholder', '::selection', ':disabled'];
exports.CARD_ELEMENT_STYLE_VARIANT_SELECTORS = CARD_ELEMENT_STYLE_VARIANT_SELECTORS;
const CARD_ELEMENT_STYLE_VARIANTS = ['base', 'complete', 'invalid', 'empty'];
exports.CARD_ELEMENT_STYLE_VARIANTS = CARD_ELEMENT_STYLE_VARIANTS;
const CARD_ELEMENT_STYLE_FONTS_ATTR = 'fonts';
exports.CARD_ELEMENT_STYLE_FONTS_ATTR = CARD_ELEMENT_STYLE_FONTS_ATTR;